document.addEventListener('DOMContentLoaded', () => {
  const installationCheckbox = document.querySelector(
    'input[name="addon_installation"][data-installation-toggle]'
  );
  const questionsWrapper = document.querySelector('[data-installation-questions]');

  if (!installationCheckbox || !questionsWrapper) return;

  const questions = questionsWrapper.querySelectorAll('.installation-questions__item');
  const errorEl = questionsWrapper.querySelector('[data-installation-error]') || null;

  // Find product form & add-to-cart button (Dawn-compatible)
  let productForm = installationCheckbox.closest('form');
  if (!productForm) {
    const productFormElement = installationCheckbox.closest('product-form');
    if (productFormElement) {
      productForm = productFormElement.querySelector('form');
    }
  }

  const addToCartButton =
    productForm &&
    (productForm.querySelector('button[type="submit"][name="add"]') ||
      productForm.querySelector('button[name="add"]'));

  if (!addToCartButton) return;

  const originalDisabled = addToCartButton.disabled || false;
  addToCartButton.setAttribute(
    'data-installation-original-disabled',
    originalDisabled ? 'true' : 'false'
  );

  function lockATC() {
    addToCartButton.disabled = true;
    addToCartButton.setAttribute('data-installation-lock', 'true');
  }

  function unlockATC() {
    addToCartButton.removeAttribute('data-installation-lock');
    const wasDisabled =
      addToCartButton.getAttribute('data-installation-original-disabled') === 'true';
    addToCartButton.disabled = wasDisabled;
  }

  function resetQuestions() {
    questions.forEach((q) => {
      q.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.checked = false;
      });
    });
    if (errorEl) errorEl.hidden = true;
  }

  function updateVisibility(open) {
    if (open) {
      questionsWrapper.classList.remove('installation-questions--hidden');
      questionsWrapper.classList.add('installation-questions--open');
    } else {
      questionsWrapper.classList.remove('installation-questions--open');
      questionsWrapper.classList.add('installation-questions--hidden');
    }
  }

  function validateQuestions() {
    // If Installation not checked → all good, ATC free
    if (!installationCheckbox.checked) {
      updateVisibility(false);
      resetQuestions();
      unlockATC();
      return;
    }

    // Installation checked → show block
    updateVisibility(true);

    // If no questions configured: allow ATC immediately
    if (!questions.length) {
      if (errorEl) errorEl.hidden = true;
      unlockATC();
      return;
    }

    let allAnswered = true;
    let allYes = true;

    questions.forEach((q) => {
      const radios = q.querySelectorAll('input[type="radio"]');
      if (!radios.length) return;

      const name = radios[0].name;
      const checked = questionsWrapper.querySelector(`input[name="${name}"]:checked`);

      if (!checked) {
        allAnswered = false;
      } else if (checked.value !== 'yes') {
        allYes = false;
      }
    });

    if (!allAnswered) {
      // Waiting for user to finish → no error, ATC locked
      if (errorEl) errorEl.hidden = true;
      lockATC();
      return;
    }

    if (allYes) {
      if (errorEl) errorEl.hidden = true;
      unlockATC();
    } else {
      if (errorEl) errorEl.hidden = false;
      lockATC();
    }
  }

  // Checkbox toggle
  installationCheckbox.addEventListener('change', () => {
    if (!installationCheckbox.checked) {
      // Hide everything and free ATC
      validateQuestions();
    } else {
      // Show panel and lock ATC until answers are valid
      lockATC();
      validateQuestions();
    }
  });

  // Question radio change
  questions.forEach((q) => {
    q.addEventListener('change', validateQuestions);
  });

  // Initial state
  validateQuestions();
});
